import http from "@/utils/http";


export const WechatOpenOauthApi = {

    render(params) {
        return http.get(`/wechat/oauth/render`,params)
    },
    binding(data) {
        return http.post(`/wechat/oauth/binding`,data)
    },
}